import React from 'react';
import './App.css';
import Navbar from "./components/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";
import HeroSection from './components/HeroSection';
import ContentSection from './components/ContentSection';
import Partenaires from "./components/Partenaires";
import ElecGenerale from "./components/Specialisations/ElecGenerale";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import EnergieRen from "./components/Specialisations/EnergieRen";
import Domotique from "./components/Specialisations/Domotique";
import Securite from "./components/Specialisations/Securite";
import MobiliteElec from "./components/Specialisations/MobiliteElec";
import Toolbar from "@mui/material/Toolbar";
import Partenariat from "./components/Partenariat";

function App() {
    return (
        // <BrowserRouter>
        //     <ScrollToTop />
        //     <Box sx={{ backgroundColor: '#f3f4f5' }}>
        //         <Navbar /> {/* Navbar ici */}
        //
        //         {/* Contenu avec padding supérieur */}
        //         <Box sx={{ pt: 10 }}> {/* Ajustez cette valeur selon la hauteur de votre Navbar */}
        //             <Routes>
        //                 <Route path="/" element={
        //                     <>
        //                         <HeroSection />
        //                         <ContentSection />
        //                         <Partenaires />
        //                         <ContactUs />
        //                     </>
        //                 } />
        //                 <Route path="/electricite-generale" element={<ElecGenerale />} />
        //                 <Route path="/mobilite-electrique" element={<MobiliteElec />} />
        //                 <Route path="/energie-renouvelable" element={<EnergieRen />} />
        //                 <Route path="/domotique" element={<Domotique />} />
        //                 <Route path="/sécurité" element={<Securite />} />
        //             </Routes>
        //         </Box>
        //
        //         <Footer />
        //     </Box>
        // </BrowserRouter>

        <BrowserRouter>
            <ScrollToTop />
            <Box sx={{ backgroundColor: 'rgba(243,241,241,0.22)' }}>
                <Navbar />
                <Toolbar /> {/* Ajoutez cette ligne */}

                {/* Remplacez le Box avec padding par : */}
                <Box component="main" sx={{
                    flexGrow: 1,
                    minHeight: '100vh',
                    // Si vous voulez un padding supplémentaire :
                    pt: 2 // Ajustez cette valeur selon vos besoins
                }}>
                    <Routes>
                        <Route path="/" element={
                            <>
                                <HeroSection />
                                <ContentSection />
                                <Partenaires />
                                <ContactUs />
                            </>
                        } />
                        {/* ... autres routes ... */}
                        <Route path="/electricite-generale" element={<ElecGenerale />} />
                        <Route path="/mobilite-electrique" element={<MobiliteElec />} />
                        <Route path="/energie-renouvelable" element={<EnergieRen />} />
                        <Route path="/domotique" element={<Domotique />} />
                        <Route path="/sécurité" element={<Securite />} />
                        <Route path="/demande-partenariat" element={<Partenariat />} />
                    </Routes>
                </Box>

                <Footer />
            </Box>
        </BrowserRouter>
    );
}

export default App;
